module.exports = __webpack_public_path__ + "img/pattern1.d3708e3.svg";